import './index.css';
import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var styles = {"fill-politico-red":"politico_style___livFDDVW6K","styles":"politico_style___ErGfgMUnoP"};

var useNavigator = function useNavigator() {
  if (typeof window === 'undefined') {
    return false;
  } else {
    return /iPad|iPhone|iPod|Android/.test(navigator.userAgent) && !window.MSStream;
  }
};

var Share =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Share, _React$PureComponent);

  function Share() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Share);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Share)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getCanonical", function () {
      return document.querySelector('link[rel=canonical]') && document.querySelector('link[rel=canonical]').href || window.location.href;
    });

    _defineProperty(_assertThisInitialized(_this), "getTitle", function () {
      return document.querySelector('meta[property="og:title"]') && document.querySelector('meta[property="og:title"]').getAttribute('content') || document.querySelector('meta[property="twitter:title"]') && document.querySelector('meta[property="twitter:title"]').getAttribute('content') || document.querySelector('title') && document.querySelector('title').innerText || '';
    });

    _defineProperty(_assertThisInitialized(_this), "getStatus", function () {
      var tweetText = get(_this.props, 'tweet', '');
      var uri = window.location.href;
      return encodeURIComponent("".concat(tweetText, "\n\n").concat(uri));
    });

    _defineProperty(_assertThisInitialized(_this), "navigatorShare", function () {
      if (useNavigator() && navigator.share) {
        navigator.share({
          title: _this.getTitle(),
          url: _this.getCanonical()
        }).catch(function (e) {});
        return true;
      } else {
        return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fbHandlder", function (e) {
      e.preventDefault();

      _this.props.onFb();

      if (!_this.navigatorShare()) {
        var u = encodeURIComponent(window.location.href);
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(u));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "mailHandler", function (e) {
      _this.props.onMail();

      if (_this.navigatorShare()) {
        e.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "twitterHandler", function (e) {
      e.preventDefault();

      _this.props.onTwitter();

      if (!_this.navigatorShare()) {
        var status = _this.getStatus();

        window.open("https://twitter.com/intent/tweet?text=".concat(status));
      }
    });

    return _this;
  }

  _createClass(Share, [{
    key: "render",
    value: function render() {
      var subject = encodeURIComponent(this.props.subject);
      var status = typeof window === 'undefined' ? '' : this.getStatus();
      return React.createElement("div", {
        className: classnames('share', styles.styles)
      }, React.createElement("a", {
        href: "",
        className: "bt-icon custom-icon--facebook",
        target: "_blank",
        onClick: this.fbHandlder
      }, React.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xlinkHref: "http://www.w3.org/1999/xlink",
        width: "14",
        height: "14",
        fill: "white",
        viewBox: "0 0 15 15"
      }, React.createElement("path", {
        d: "M9.229 15.988h-3.305v-7.989h-1.652v-2.754h1.652v-1.653c0-2.246 0.932-3.582 3.581-3.582h2.206v2.754h-1.378c-1.031 0-1.1 0.385-1.1 1.103l-0.004 1.378h2.498l-0.292 2.754h-2.206v7.989z"
      }))), React.createElement("a", {
        href: "",
        className: "bt-icon bt-icon--twitter",
        target: "_blank",
        onClick: this.twitterHandler
      }), React.createElement("a", {
        href: "mailto:?subject=".concat(subject, "&body=").concat(status),
        className: "bt-icon bt-icon--mail",
        target: "_blank",
        onClick: this.mailHandler
      }));
    }
  }]);

  return Share;
}(React.PureComponent);

Share.defaultProps = {
  subject: '',
  tweet: '',
  onFb: function onFb() {},
  onTwitter: function onTwitter() {},
  onMail: function onMail() {}
};
var activateSocialButtons = function activateSocialButtons(props) {
  var tweetText = get(props, 'tweet', '');
  var uri = window.location.href;
  var status = encodeURIComponent("".concat(tweetText, "\n\n").concat(uri));
  var subject = encodeURIComponent(get(props, 'subject', ''));
  document.querySelector('.custom-icon--facebook').addEventListener('click', function (e) {
    e.preventDefault();
    var u = encodeURIComponent(uri);
    window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(u));
  });
  document.querySelector('.bt-icon--twitter').addEventListener('click', function (e) {
    e.preventDefault();
    window.open("https://twitter.com/intent/tweet?text=".concat(status));
  });
  var mailIcon = document.querySelector('.bt-icon--mail');
  mailIcon.target = '';
  mailIcon.href = "mailto:?subject=".concat(subject, "&body=").concat(status);
};

export default Share;
export { activateSocialButtons };
